import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "summary_statistic",
  "use": "summary_statistic-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"summary_statistic\"><path d=\"M3.5 11.666V6.334A2.837 2.837 0 0 1 6.334 3.5h5.332A2.837 2.837 0 0 1 14.5 6.334V11H16V6.334A4.333 4.333 0 0 0 11.666 2H6.334A4.333 4.333 0 0 0 2 6.334v5.332A4.333 4.333 0 0 0 6.334 16H11v-1.5H6.334A2.837 2.837 0 0 1 3.5 11.666M9.75 12V8h-1.5v4zM16 14.5V12h-1.5v2.5H12V16h2.5v2H16v-2h2v-1.5zM5.25 12h1.5V9h-1.5zm7.5-6h-1.5v6h1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol